export default __webpack_public_path__ + "static/media/gestaoexecucao.d570b02f.svg";